import { heapTrack } from '../../heap';

export function trackParcelFinderSearch(search, results) {
  const { matchedEntity } = results;
  heapTrack('Parcel Finder - Search', { searchQuery: search, matchedEntity });
}
